import { render, staticRenderFns } from "./TA.vue?vue&type=template&id=542de2f6"
import script from "./TA.vue?vue&type=script&lang=js"
export * from "./TA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports